<template lang="pug">
  .component-invoice-action-buttons(v-if="entity")
    .dropdown-actions(v-if="item")
      ul.dropdown.menu(v-if="item", data-dropdown-menu='', v-f="")
        li
          a(href='#Item-1') Action
          ul.menu
            li(v-if="(entity.type === 'INVOICE' || entity.type === 'PROFORMA') && entity.status !== 'PAID'")
              invoice-reveal-pay(:invoice="entity", @payInvoice="payInvoice")
            li(v-if="entity.type === 'INVOICE' && entity.status !== 'PAID'")
              invoice-reveal-mark-as-paid(:invoice="entity", @setPaid="setPaid")
            li(v-if="entity.type === 'INVOICE' && entity.status !== 'CANCELED'")
              invoice-reveal-void(:invoice="entity")
            li(v-if="$isModuleEnabled('italian-e-invoice')")
              button.button(v-on:click="downloadXML") Scarica fattura XML
            li(v-if="$isModuleEnabled('aruba-italian-e-invoice')")
              UpdateEinvoiceFileName(:invoice="entity")
            li(v-if="$isModuleEnabled('aruba-italian-e-invoice')")
              SendToExternal(:invoice="entity")
            li(v-if="$isModuleEnabled('aruba-italian-e-invoice')")
              EinvoiceGetStatus(:invoice="entity")
            li
              invoice-transactions(:invoice="entity")
            li(v-if="entity.type ==='PROFORMA'")
              ConvertProformaToCreditNote(:invoice="entity")
            li
              ActionButton(:confirm="true", :action="markAsAwaitingPayment") Mark as awaiting payment


      button.button.small(v-on:click="openUrl(entity.url)")
        span
          i.fa.fa-file-pdf-o
          | &nbsp; Download
      is-module-enabled(module="italian-e-invoice")
        button.button.small(v-on:click="downloadXML")
          span
            i.fa.fa-code
            | &nbsp; Download XML

        a(href="xmlUrl", v-if="xmlUrl")
    .dropdown-buttons(v-else)
      invoice-reveal-pay(v-if="(invoice.type === 'INVOICE' || entity.type === 'PROFORMA') && invoice.status !== 'PAID' && invoice.status !== 'CANCELED' ", :invoice="entity", @payInvoice="payInvoice")
      invoice-reveal-mark-as-paid(v-if="invoice.type === 'INVOICE' && invoice.status !== 'PAID' && invoice.status !== 'CANCELED'", :invoice="entity", @setPaid="setPaid")
      invoice-reveal-void(v-if="invoice.type === 'INVOICE' && invoice.status !== 'CANCELED'", :invoice="entity")
      EinvoiceGetStatus(v-if="$isModuleEnabled('aruba-italian-e-invoice') && (invoice.type === 'INVOICE' || entity.type === 'CREDIT NOTE')", :invoice="entity")
      SendToExternal(v-if="$isModuleEnabled('aruba-italian-e-invoice') && (invoice.type === 'INVOICE' || entity.type === 'CREDIT NOTE')", :invoice="entity")
      ActionButton(:confirm="true", :action="markAsAwaitingPayment") Mark as awaiting payment
      invoice-transactions(:invoice="entity")
      invoice-records(:invoice="entity")
</template>
<script type="text/babel">
import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
import MaggieHelper from 'src/maggieHelper'
import ConfirmDialog from '../ConfirmDialog'
import Reveal from '../Reveal'
import InvoiceRevealVoid from './reveal/InvoiceRevealVoid.vue'
import InvoiceRevealMarkAsPaid from './reveal/InvoiceRevealMarkAsPaid'
import InvoiceRevealPay from './reveal/InvoiceRevealPay'
import InvoiceTransactions from './reveal/InvoiceRevealTransactions'
import IsModuleEnabled from '../../IsModuleEnabled'
import CardN from '../../CardN'
import ModalReveal from '../../foundation/ModalReveal'
import EinvoiceGetStatus from '../../../backoffice/modules/einvoice/EinvoiceGetStatus'
import SendToExternal from '../../../backoffice/modules/einvoice/SendToExternalService'
import InvoiceRecords from './reveal/InvoiceRevealRecords'
import UpdateEinvoiceFileName from '../../../backoffice/modules/einvoice/UpdateEinvoiceFileName'
import ActionButton from "../ActionButton";
import ConvertProformaToCreditNote from "./reveal/ConvertProformaToCreditNote.vue";

export default {
  name: 'InvoiceActionButtons',
  components: {
    ConvertProformaToCreditNote,
    ActionButton,
    UpdateEinvoiceFileName,
    InvoiceRecords,
    InvoiceTransactions,
    InvoiceRevealPay,
    InvoiceRevealMarkAsPaid,
    InvoiceRevealVoid,
    Reveal,
    ConfirmDialog,
    SendToExternal,
    EinvoiceGetStatus,
    ModalReveal,
    CardN,
    IsModuleEnabled,
  },
  data() {
    return {
      entity: null,
      xmlUrl: null,
    }
  },
  created() {
    if (!this.invoice) {
      KeplerBackofficeSdk.invoices.select(this.$route.params.id).get((item) => {
        this.entity = item
      })

    } else {
      this.entity = this.invoice
    }
  },
  methods: {
    payInvoice() {
      KeplerBackofficeSdk.invoices.select(this.entity).payInvoice((response) => {
        this.entity = response
        MaggieHelper.notification('pay-esit', 'Invoice has been paid')
      })
    },
    setPaid() {
      KeplerBackofficeSdk.invoices.select(this.entity).setPaid((response) => {
        this.entity = response
        MaggieHelper.notification('paid-esit', 'Invoice has been set as paid')
      })
    },
    openUrl: function (url) {
      window.open(url, '_blank')
    },
    downloadXML() {
      KeplerBackofficeSdk.invoices.select(this.entity).downloadXML((data) => {
        window.open(data, '_blank')
      })
    },
    markAsAwaitingPayment() {
      return KeplerBackofficeSdk.invoices.select(this.entity).setAwaitingPayment((response) => {
        this.entity = response
        MaggieHelper.notification('Invoice', 'Invoice has been set as awaiting payment')
      })
    }
  },
  props: ['invoice', 'item']
}
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// InvoiceButtons.vue?89ea15fc